import {Component} from '@angular/core';

@Component({
  selector: 'app-unauthorized-header',
  templateUrl: './unauthorized-header.component.html',
  styleUrl: './unauthorized-header.component.css',
  standalone: false
})
export class UnauthorizedHeaderComponent {
  isCurrentPageHref(url: string) {
    return window.location.pathname.includes(url);
  }
}
